/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccommodationsForMap } from '../models/AccommodationsForMap';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AccommodationsForMapService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves a AccommodationsForMap resource.
     * Retrieves a AccommodationsForMap resource.
     * @param maxLat Latitude (vertical) of top-left
     * @param minLon Longitude (horizontal) of top-left
     * @param minLat Latitude (vertical) of bottom-right
     * @param maxLon Longitude (horizontal) of bottom-right
     * @param limit
     * @returns AccommodationsForMap AccommodationsForMap resource
     * @throws ApiError
     */
    public accommodationForMap(
        maxLat: number,
        minLon: number,
        minLat: number,
        maxLon: number,
        limit?: number,
    ): CancelablePromise<AccommodationsForMap> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/map/accommodations',
            query: {
                limit: limit,
                'max-lat': maxLat,
                'min-lon': minLon,
                'min-lat': minLat,
                'max-lon': maxLon,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
